
// Seguridad
import { securityProvider } from '@/api/securityProvider';
import AuthService from '@pjn/services/AuthService';
import MagistradoService from './MagistradoService';
import ExpedienteService from './ExpedienteService';
import DenunciaService from './DenunciaService';
import ConfiguracionService from './ConfiguracionService';

// Servicios


// Crea y exporta singleton del service de autenticacion, para que se pueda inyectar en cualquier componente o clase
export const authService = new AuthService(securityProvider, {
  appTitle: 'Sistema de denuncias',
  accessPermissionName: 'acceder',
  unauthorizedUrl: 'http://static.pjn.gov.ar/apps/errors/unauthorized.html',
  unexpectedErrorUrl: 'http://static.pjn.gov.ar/apps/errors/unexpected.html'
});
// Crea y exporta singleton del service, para que se pueda inyectar en cualquier componente o clase
// Servicios globales
export const magistradoService = new MagistradoService();
export const expedienteService = new ExpedienteService();
export const denunciaService = new DenunciaService();
export const configuracionService = new ConfiguracionService();

